import { render } from "./GoodsPrint.vue?vue&type=template&id=a5591b98&scoped=true"
import script from "./GoodsPrint.vue?vue&type=script&lang=js"
export * from "./GoodsPrint.vue?vue&type=script&lang=js"

import "./GoodsPrint.vue?vue&type=style&index=0&id=a5591b98&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5591b98"]])

export default __exports__